/* C'est du Joly — moteur générique d'options produits par tags. */
(function () {
  'use strict';

  if (window.__cdjProductUpsellInitialized || window.__cdjMatchingThreadUpsellInitialized) return;
  window.__cdjProductUpsellInitialized = true;
  window.__cdjMatchingThreadUpsellInitialized = true;

  var ROOT_SELECTOR = '[data-cdj-product-upsell], [data-cdj-thread-upsell]';
  var OPTION_SELECTOR = '[data-cdj-upsell-option]';
  var CHECKBOX_SELECTOR = '[data-cdj-upsell-checkbox]';
  var QUANTITY_INPUT_SELECTOR = '[data-cdj-upsell-quantity]';
  var QUANTITY_DECREASE_SELECTOR = '[data-cdj-upsell-quantity-decrease]';
  var QUANTITY_INCREASE_SELECTOR = '[data-cdj-upsell-quantity-increase]';
  var QUANTITY_BUTTON_SELECTOR = QUANTITY_DECREASE_SELECTOR + ', ' + QUANTITY_INCREASE_SELECTOR;
  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  var SUBMIT_SELECTOR = '[data-atc-form]';
  var STICKY_SUBMIT_SELECTOR = '[data-sticky-addtocart] [data-action-atc]';
  var busyForms = new WeakSet();

  function toInteger(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) ? number : fallback;
  }

  function normalizeCents(value) {
    if (value === null || value === undefined || value === '') return 0;
    if (typeof value === 'number') return Math.max(0, Math.round(value));

    var text = String(value).trim().replace(/\s/g, '').replace(',', '.');
    if (!text) return 0;
    var number = Number(text);
    if (!Number.isFinite(number)) return 0;

    /* Shopify's Ajax endpoints normally return integer cents. The decimal
       branch keeps the integration safe if a localized endpoint returns 5.99. */
    return text.indexOf('.') !== -1 ? Math.max(0, Math.round(number * 100)) : Math.max(0, Math.round(number));
  }

  function formatMoney(cents) {
    if (
      window.T4SThemeSP &&
      window.T4SThemeSP.Currency &&
      typeof window.T4SThemeSP.Currency.formatMoney === 'function'
    ) {
      return window.T4SThemeSP.Currency.formatMoney(cents);
    }

    var currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      (window.T4Sconfigs && window.T4Sconfigs.cartCurrency) ||
      'EUR';
    var locale = document.documentElement.lang || 'fr-BE';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function escapeHtml(value) {
    var element = document.createElement('div');
    element.textContent = value == null ? '' : String(value);
    return element.innerHTML;
  }

  function getRootUrl() {
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (window.T4Sroutes && window.T4Sroutes.root_url) ||
      '/';
    return String(root).replace(/\/?$/, '/');
  }

  function getForm(root) {
    return root ? root.closest(FORM_SELECTOR) : null;
  }

  function getRootForForm(form) {
    return form ? form.querySelector(ROOT_SELECTOR) : null;
  }

  function isMainProductRoot(root) {
    var productContainer = root && root.closest('[data-product-featured]');
    var configuration = productContainer && productContainer.getAttribute('data-product-featured');
    return Boolean(configuration && configuration.indexOf('\"isMainProduct\":true') !== -1);
  }

  function getStickyContext(button) {
    if (!button) return null;

    var stickyContainer = button.closest('[data-sticky-addtocart]');
    if (!stickyContainer) return null;

    var requestedVariantId = String(button.dataset.variantId || '').trim();
    var quantityField = stickyContainer.querySelector('[data-quantity-value][name="quantity"]');
    var requestedQuantity = Math.max(1, toInteger(quantityField && quantityField.value, 1));
    var roots = Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
    var mainMatch = null;
    var variantMatch = null;
    var mainFallback = null;
    var firstFallback = null;

    roots.forEach(function (root) {
      var form = getForm(root);
      if (!form) return;

      var context = {
        root: root,
        form: form,
        variantId: requestedVariantId || getSelectedVariantId(form),
        quantity: requestedQuantity
      };

      if (!firstFallback) firstFallback = context;
      if (isMainProductRoot(root) && !mainFallback) mainFallback = context;
      if (requestedVariantId && String(getSelectedVariantId(form)) === requestedVariantId && !variantMatch) {
        variantMatch = context;
      }
      if (requestedVariantId && isMainProductRoot(root) && String(getSelectedVariantId(form)) === requestedVariantId) {
        mainMatch = context;
      }
    });

    return mainMatch || mainFallback || variantMatch || firstFallback;
  }

  function getOptionCheckbox(option) {
    return option ? option.querySelector(CHECKBOX_SELECTOR) : null;
  }

  function getOptionQuantityInput(option) {
    return option ? option.querySelector(QUANTITY_INPUT_SELECTOR) : null;
  }

  function optionSelectionQuantity(option) {
    return Math.max(1, toInteger(option && option.dataset.selectionQuantity, 1));
  }

  function optionQuantityLimits(option) {
    var input = getOptionQuantityInput(option);
    var minimum = Math.max(0, toInteger(input && input.getAttribute('min'), 0));
    var selectedMinimum = optionSelectionQuantity(option);
    var configuredMaximum = toInteger(
      input && input.getAttribute('max'),
      toInteger(option && option.dataset.maxQuantity, 100)
    );
    var maximum = Math.max(selectedMinimum, configuredMaximum || 100);

    return { minimum: minimum, selectedMinimum: selectedMinimum, maximum: maximum };
  }

  function clampOptionQuantity(option, value) {
    var limits = optionQuantityLimits(option);
    var fallback = toInteger(option && option.dataset.quantity, limits.minimum);
    var quantity = toInteger(value, fallback);
    return Math.min(limits.maximum, Math.max(limits.minimum, quantity));
  }

  function getOptionQuantity(option) {
    var input = getOptionQuantityInput(option);
    return clampOptionQuantity(option, input ? input.value : option && option.dataset.quantity);
  }

  function updateOptionQuantityMeta(option, quantity) {
    var meta = option && option.querySelector('[data-cdj-upsell-quantity-meta]');
    var root = option && option.closest(ROOT_SELECTOR);
    if (!meta || !root) return;

    if (quantity === 1) {
      meta.textContent = root.dataset.quantityOneLabel || '1 item';
      return;
    }

    var template = root.dataset.quantityManyTemplate || '__count__ items';
    meta.textContent = template.replace(/__count__/g, String(quantity));
  }

  function syncOptionQuantityControls(option) {
    var input = getOptionQuantityInput(option);
    if (!input) return;

    var quantity = clampOptionQuantity(option, input.value);
    var limits = optionQuantityLimits(option);
    var unavailable = option.dataset.state === 'unavailable' || option.dataset.state === 'loading';
    var decrease = option.querySelector(QUANTITY_DECREASE_SELECTOR);
    var increase = option.querySelector(QUANTITY_INCREASE_SELECTOR);
    var wrapper = option.querySelector('[data-cdj-upsell-quantity-wrapper]');

    var checkbox = getOptionCheckbox(option);
    var selected = Boolean(checkbox && checkbox.checked && !checkbox.disabled);
    var removeAtOne = selected && quantity <= limits.selectedMinimum && !unavailable;

    input.disabled = unavailable;
    if (decrease) {
      decrease.disabled = unavailable || quantity <= limits.minimum;
      decrease.classList.toggle('is-remove-at-one', removeAtOne);
      decrease.setAttribute(
        'aria-label',
        removeAtOne
          ? (decrease.dataset.cdjUpsellDeselectLabel || 'Deselect option')
          : (decrease.dataset.cdjUpsellDecreaseLabel || 'Decrease quantity')
      );
    }
    if (increase) increase.disabled = unavailable || quantity >= limits.maximum;
    if (wrapper) wrapper.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
  }

  function selectOptionFromQuantity(option, quantity) {
    var checkbox = getOptionCheckbox(option);
    if (!checkbox || checkbox.disabled || option.dataset.state === 'unavailable') return false;

    checkbox.checked = quantity > 0;
    setOptionSelectedState(option);
    return checkbox.checked;
  }

  function setOptionQuantity(option, value, configuration) {
    configuration = configuration || {};
    if (!option) return 1;

    var input = getOptionQuantityInput(option);
    var quantity = clampOptionQuantity(option, value);

    option.dataset.quantity = String(quantity);
    if (input) input.value = String(quantity);
    if (configuration.select) selectOptionFromQuantity(option, quantity);

    updateOptionQuantityMeta(option, quantity);
    syncOptionQuantityControls(option);

    if (
      configuration.renderPrice !== false &&
      option.dataset.state === 'ready' &&
      option.dataset.priceKnown !== 'false'
    ) {
      renderOptionPrice(
        option,
        toInteger(option.dataset.price, 0),
        toInteger(option.dataset.comparePrice, toInteger(option.dataset.price, 0))
      );
    }

    if (configuration.dispatch !== false) dispatchPriceUpdate(option);
    return quantity;
  }

  function selectedOptions(root) {
    if (!root) return [];
    return Array.prototype.filter.call(root.querySelectorAll(OPTION_SELECTOR), function (option) {
      var checkbox = getOptionCheckbox(option);
      return checkbox && checkbox.checked && !checkbox.disabled && option.dataset.state !== 'unavailable';
    });
  }

  function setOptionSelectedState(option) {
    var checkbox = getOptionCheckbox(option);
    var isSelected = Boolean(checkbox && checkbox.checked && !checkbox.disabled);
    option.classList.toggle('is-selected', isSelected);

    var form = option.closest(FORM_SELECTOR);
    var root = option.closest(ROOT_SELECTOR);
    if (form && root) {
      form.classList.toggle('cdj-has-selected-upsell', selectedOptions(root).length > 0);
    }
  }

  function dispatchPriceUpdate(option) {
    var quantity = getOptionQuantity(option);
    var checkbox = getOptionCheckbox(option);
    var selectedQuantity = checkbox && checkbox.checked ? quantity : 0;
    var price = toInteger(option.dataset.price, 0);
    var comparePrice = toInteger(option.dataset.comparePrice, price);

    option.dispatchEvent(new CustomEvent('cdj:upsell-price-updated', {
      bubbles: true,
      detail: {
        price: price,
        comparePrice: comparePrice,
        quantity: selectedQuantity,
        linePrice: price * selectedQuantity,
        lineComparePrice: comparePrice * selectedQuantity,
        state: option.dataset.state || 'unknown'
      }
    }));
  }

  function renderOptionPrice(option, price, comparePrice) {
    var priceElement = option.querySelector('[data-cdj-upsell-price]');
    if (!priceElement) return;

    var checkbox = getOptionCheckbox(option);
    var selected = Boolean(checkbox && checkbox.checked && !checkbox.disabled);
    var quantity = selected ? Math.max(1, getOptionQuantity(option)) : optionSelectionQuantity(option);
    var finalPrice = Math.max(0, price) * quantity;
    var referencePrice = Math.max(Math.max(0, price), comparePrice || Math.max(0, price)) * quantity;
    var html = '<span class="cdj-thread-upsell__price-prefix">+</span> ';

    if (referencePrice > finalPrice) {
      html += '<del>' + escapeHtml(formatMoney(referencePrice)) + '</del> ';
      html += '<ins>' + escapeHtml(formatMoney(finalPrice)) + '</ins>';
    } else {
      html += '<span>' + escapeHtml(formatMoney(finalPrice)) + '</span>';
    }

    priceElement.innerHTML = html;
  }

  function setOptionReady(option, variant) {
    var checkbox = getOptionCheckbox(option);
    var price = normalizeCents(variant && variant.price);
    var comparePrice = normalizeCents(variant && variant.compare_at_price);
    var available = !variant || variant.available !== false;
    var expectedProductId = String(option.dataset.productId || '');
    var actualProductId = variant && variant.product_id != null ? String(variant.product_id) : '';

    if (expectedProductId && actualProductId && expectedProductId !== actualProductId) {
      available = false;
    }

    option.dataset.price = String(price);
    option.dataset.comparePrice = String(Math.max(price, comparePrice || price));
    option.dataset.priceKnown = 'true';
    option.classList.remove('is-loading');

    if (available) {
      option.dataset.state = 'ready';
      option.classList.remove('is-unavailable');
      if (checkbox) checkbox.disabled = false;
      setOptionQuantity(option, option.dataset.quantity, { dispatch: false });
    } else {
      setOptionUnavailable(option);
      return;
    }

    setOptionSelectedState(option);
    dispatchPriceUpdate(option);
  }

  function setOptionUnknown(option) {
    var checkbox = getOptionCheckbox(option);
    var root = option.closest(ROOT_SELECTOR);
    var priceElement = option.querySelector('[data-cdj-upsell-price]');

    option.dataset.price = '0';
    option.dataset.comparePrice = '0';
    option.dataset.priceKnown = 'false';
    option.dataset.state = 'ready';
    option.classList.remove('is-loading', 'is-unavailable');
    if (checkbox) checkbox.disabled = false;
    setOptionQuantity(option, option.dataset.quantity, { dispatch: false, renderPrice: false });
    if (priceElement) {
      priceElement.textContent = '+ ' + ((root && root.dataset.fallbackPriceLabel) || 'Prix ajouté au panier');
    }
    setOptionSelectedState(option);
    dispatchPriceUpdate(option);
  }

  function setOptionUnavailable(option) {
    var checkbox = getOptionCheckbox(option);
    var root = option.closest(ROOT_SELECTOR);
    var priceElement = option.querySelector('[data-cdj-upsell-price]');

    option.dataset.price = '0';
    option.dataset.comparePrice = '0';
    option.dataset.priceKnown = 'false';
    option.dataset.state = 'unavailable';
    option.classList.remove('is-loading', 'is-selected');
    option.classList.add('is-unavailable');
    if (checkbox) {
      checkbox.checked = false;
      checkbox.disabled = true;
    }
    if (priceElement) {
      priceElement.textContent = (root && root.dataset.unavailableLabel) || 'Indisponible';
    }
    syncOptionQuantityControls(option);
    setOptionSelectedState(option);
    dispatchPriceUpdate(option);
  }

  function fetchVariant(option) {
    var variantId = String(option.dataset.variantId || '').trim();
    var productId = String(option.dataset.productId || '').trim();
    var productHandle = String(option.dataset.productHandle || '').trim();

    if (!variantId) {
      setOptionUnavailable(option);
      return Promise.resolve(null);
    }

    /* The product picker normally hydrates the option directly in Liquid.
       This Product Ajax API fallback covers a freshly imported theme before
       Shopify has resolved the product setting. */
    if (!productHandle) {
      setOptionUnknown(option);
      return Promise.resolve(null);
    }

    var url = getRootUrl() + 'products/' + encodeURIComponent(productHandle) + '.js';
    return fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          var error = new Error('Product metadata unavailable');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(function (product) {
        var actualProductId = product && product.id != null ? String(product.id) : '';
        var variants = product && Array.isArray(product.variants) ? product.variants : [];
        var variant = variants.find(function (candidate) {
          return candidate && String(candidate.id) === variantId;
        });

        if (!variant || (productId && actualProductId && productId !== actualProductId)) {
          setOptionUnavailable(option);
          return null;
        }

        var hydratedVariant = Object.assign({}, variant, { product_id: product.id });
        setOptionReady(option, hydratedVariant);
        return hydratedVariant;
      })
      .catch(function () {
        /* A metadata problem must not block the exact Variant ID supplied by
           the merchant. The price will then be confirmed by Shopify in cart. */
        setOptionUnknown(option);
        return null;
      });
  }

  function showError(root, message) {
    if (!root) return;
    var errorElement = root.querySelector('[data-cdj-upsell-error]');
    if (!errorElement) return;

    errorElement.textContent = message || root.dataset.addError || 'Impossible d’ajouter ces produits.';
    errorElement.hidden = false;
    errorElement.setAttribute('aria-hidden', 'false');
  }

  function clearError(root) {
    if (!root) return;
    var errorElement = root.querySelector('[data-cdj-upsell-error]');
    if (!errorElement) return;

    errorElement.textContent = '';
    errorElement.hidden = true;
    errorElement.setAttribute('aria-hidden', 'true');
  }

  function showThemeNotice(message) {
    if (window.T4SThemeSP && typeof window.T4SThemeSP.Notices === 'function') {
      window.T4SThemeSP.Notices(message);
    }
  }

  function validateRequiredProperties(form, root, submitButton) {
    if (!form || !root) return false;

    if (
      (submitButton && submitButton.disabled) ||
      (submitButton && submitButton.getAttribute('aria-disabled') === 'true')
    ) {
      var optionMessage =
        (window.T4SProductStrings && window.T4SProductStrings.pleaseChooseOptions) ||
        root.dataset.requiredError;
      showError(root, optionMessage);
      showThemeNotice(optionMessage);
      return false;
    }

    var hasError = false;
    form.querySelectorAll('[data-field-required]').forEach(function (field) {
      var wrapper = field.closest('[data-item-property-field]');
      var isChoice = wrapper && (
        wrapper.classList.contains('is--type-radio') ||
        wrapper.classList.contains('is--type-checkbox')
      );
      var isValid = isChoice
        ? Boolean(wrapper.querySelector('input[name]:checked'))
        : String(field.value || '').trim().length > 0;

      if (!isValid) {
        hasError = true;
        if (wrapper) wrapper.classList.add('is--field-emty', 'is--animated', 't4s-ani-shake');
      }
    });

    if (!hasError && typeof form.checkValidity === 'function' && !form.checkValidity()) {
      hasError = true;
      if (typeof form.reportValidity === 'function') form.reportValidity();
    }

    if (hasError) {
      var requiredMessage = root.dataset.requiredError || 'Veuillez compléter les options obligatoires du produit.';
      showError(root, requiredMessage);
      showThemeNotice(requiredMessage);
      window.setTimeout(function () {
        form.querySelectorAll('.is--field-emty.is--animated').forEach(function (element) {
          element.classList.remove('is--animated', 't4s-ani-shake');
        });
      }, 1000);
      return false;
    }

    return true;
  }

  function getSelectedVariantId(form) {
    if (!form) return '';
    var select = form.querySelector('select[name="id"]');
    if (select && select.value) return String(select.value);

    var inputs = form.querySelectorAll('input[name="id"]');
    for (var index = inputs.length - 1; index >= 0; index -= 1) {
      if (inputs[index].value) return String(inputs[index].value);
    }
    return '';
  }

  function getQuantity(form) {
    var field = form && form.querySelector('[name="quantity"]');
    return Math.max(1, toInteger(field && field.value, 1));
  }

  function getFormValues(form) {
    var values = {
      properties: {},
      sellingPlan: null,
      hasFile: false
    };
    var data = new FormData(form);

    data.forEach(function (value, key) {
      if (typeof File !== 'undefined' && value instanceof File) {
        if (value.size > 0) values.hasFile = true;
        return;
      }

      if (key === 'selling_plan' && String(value).trim()) {
        values.sellingPlan = String(value).trim();
        return;
      }

      var propertyMatch = /^properties\[(.*)\]$/.exec(key);
      if (!propertyMatch) return;

      var propertyName = propertyMatch[1];
      var propertyValue = String(value);
      if (!propertyName || !propertyValue) return;

      if (Object.prototype.hasOwnProperty.call(values.properties, propertyName)) {
        values.properties[propertyName] += ', ' + propertyValue;
      } else {
        values.properties[propertyName] = propertyValue;
      }
    });

    return values;
  }

  function parentDisplayTitle(root) {
    var productTitle = String(root.dataset.parentProductTitle || '').trim();
    var variantTitle = String(root.dataset.parentVariantTitle || '').trim();
    var defaultTitle = String(root.dataset.defaultVariantTitle || 'Default Title').trim().toLowerCase();

    if (!variantTitle || variantTitle.toLowerCase() === 'default title' || variantTitle.toLowerCase() === defaultTitle) {
      return productTitle;
    }
    return productTitle + ' — ' + variantTitle;
  }

  function createGroupId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return 'cdj-' + window.crypto.randomUUID();
    }
    return 'cdj-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function cloneProperties(properties) {
    var copy = {};
    Object.keys(properties || {}).forEach(function (key) {
      copy[key] = properties[key];
    });
    return copy;
  }

  function buildCartItems(form, root, options, overrides) {
    overrides = overrides || {};
    var parentVariantId = String(overrides.variantId || getSelectedVariantId(form));
    var parentVariantNumber = Number(parentVariantId);
    var formValues = getFormValues(form);
    var groupId = createGroupId();
    var displayTitle = parentDisplayTitle(root);
    var associationLabel = root.dataset.associationLabel || 'À assortir avec';
    var parentProperties = cloneProperties(formValues.properties);

    /* This unique private property prevents a product added with options
       from merging with an otherwise identical existing cart line. */
    parentProperties._cdj_upsell_group = groupId;
    parentProperties._cdj_has_upsell = 'true';

    var parentItem = {
      id: Number.isSafeInteger(parentVariantNumber) ? parentVariantNumber : parentVariantId,
      quantity: Math.max(1, toInteger(overrides.quantity, getQuantity(form))),
      properties: parentProperties
    };

    if (formValues.sellingPlan) parentItem.selling_plan = formValues.sellingPlan;

    var items = [parentItem];
    options.forEach(function (option) {
      var childId = String(option.dataset.variantId || '');
      var childNumber = Number(childId);
      var upsellType = option.dataset.upsellType || 'product_option';
      var configuredQuantity = getOptionQuantity(option);
      var childProperties = {};

      childProperties[associationLabel] = displayTitle;
      childProperties._cdj_upsell = 'product_option';
      childProperties._cdj_upsell_type = upsellType;
      childProperties._cdj_upsell_group = groupId;
      childProperties._cdj_upsell_label = associationLabel;
      childProperties._cdj_parent_product_id = String(root.dataset.parentProductId || '');
      childProperties._cdj_parent_variant_id = parentVariantId;

      items.push({
        id: Number.isSafeInteger(childNumber) ? childNumber : childId,
        quantity: configuredQuantity,
        parent_id: Number.isSafeInteger(parentVariantNumber) ? parentVariantNumber : parentVariantId,
        properties: childProperties
      });
    });

    return {
      items: items,
      hasFile: formValues.hasFile
    };
  }

  function sectionsForTheme() {
    var sections = ['cart_data'];
    if (!window.T4Sconfigs || window.T4Sconfigs.cartType !== 'disable') {
      sections.push('mini_cart');
    }
    if (window.QuickOrderListID) sections.push(window.QuickOrderListID);
    return sections.filter(function (section, index, all) {
      return section && all.indexOf(section) === index;
    });
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    var spinner = button.querySelector('.t4s-loading__spinner');
    var svgSpinner = button.querySelector('.t4s-svg-spinner');

    button.classList.toggle('is--loading', loading);
    if (loading) {
      if (!Object.prototype.hasOwnProperty.call(button.dataset, 'cdjPreviousAriaDisabled')) {
        button.dataset.cdjPreviousAriaDisabled = button.hasAttribute('aria-disabled')
          ? String(button.getAttribute('aria-disabled'))
          : '__missing__';
      }
      button.setAttribute('aria-disabled', 'true');
      if (spinner) spinner.hidden = false;
      if (svgSpinner) svgSpinner.hidden = false;
    } else {
      var previousState = button.dataset.cdjPreviousAriaDisabled;
      if (previousState && previousState !== '__missing__') {
        button.setAttribute('aria-disabled', previousState);
      } else if (!button.disabled) {
        button.removeAttribute('aria-disabled');
      }
      delete button.dataset.cdjPreviousAriaDisabled;
      if (spinner) spinner.hidden = true;
      if (svgSpinner) svgSpinner.hidden = true;
    }
  }

  function resetSelectedOptions(root) {
    root.querySelectorAll(OPTION_SELECTOR).forEach(function (option) {
      var checkbox = getOptionCheckbox(option);
      if (checkbox) checkbox.checked = false;
      setOptionQuantity(option, 0, { dispatch: false });
      setOptionSelectedState(option);
    });
    root.dispatchEvent(new CustomEvent('cdj:upsell-price-updated', { bubbles: true }));
  }

  function renderThemeCart(response) {
    if (window.jQuery_T4NT) {
      window.jQuery_T4NT(document).trigger('add:cart:success').trigger('add:cart:upsell');
    }
    if (window.T4SThemeSP) window.T4SThemeSP.isATCSuccess = true;

    if (
      response &&
      response.sections &&
      window.T4SThemeSP &&
      window.T4SThemeSP.Cart &&
      typeof window.T4SThemeSP.Cart.renderContents === 'function'
    ) {
      window.T4SThemeSP.Cart.renderContents(response.sections);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh:opend', { bubbles: true }));
    }
  }

  function parseResponse(response) {
    return response.json().catch(function () {
      return {};
    }).then(function (payload) {
      if (!response.ok || payload.status) {
        var message = payload.description || payload.message || 'Unable to add products to the cart.';
        var error = new Error(message);
        error.payload = payload;
        throw error;
      }
      return payload;
    });
  }

  function addBundle(form, root, button, overrides) {
    if (busyForms.has(form)) return;

    var options = selectedOptions(root);
    if (!options.length) return;
    clearError(root);

    if (!validateRequiredProperties(form, root, button)) return;

    var built = buildCartItems(form, root, options, overrides);
    if (!built.items[0].id) {
      var variantMessage =
        (window.T4SProductStrings && window.T4SProductStrings.pleaseChooseOptions) ||
        root.dataset.requiredError;
      showError(root, variantMessage);
      showThemeNotice(variantMessage);
      return;
    }

    if (built.hasFile) {
      var fileMessage = root.dataset.addError || 'Impossible d’ajouter ces options avec un fichier joint.';
      showError(root, fileMessage);
      showThemeNotice(fileMessage);
      return;
    }

    busyForms.add(form);
    setButtonLoading(button, true);

    var payload = {
      items: built.items,
      sections: sectionsForTheme().join(','),
      sections_url: window.location.pathname
    };

    fetch(getRootUrl() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(parseResponse)
      .then(function (response) {
        resetSelectedOptions(root);
        renderThemeCart(response);
      })
      .catch(function (error) {
        var message = (error && error.message) || root.dataset.addError;
        showError(root, message || root.dataset.addError);
        showThemeNotice(message || root.dataset.addError);
        if (window.jQuery_T4NT) {
          window.jQuery_T4NT(document).trigger('cart:updated', ['error']);
        }
      })
      .finally(function () {
        busyForms.delete(form);
        setButtonLoading(button, false);
      });
  }

  function initializeRoot(root) {
    if (!root || root.dataset.cdjInitialized === 'true') return;
    root.dataset.cdjInitialized = 'true';

    root.querySelectorAll(OPTION_SELECTOR).forEach(function (option) {
      var state = option.dataset.state || 'loading';
      setOptionSelectedState(option);

      if (state === 'ready') {
        setOptionReady(option, {
          price: toInteger(option.dataset.price, 0),
          compare_at_price: toInteger(option.dataset.comparePrice, toInteger(option.dataset.price, 0)),
          available: true,
          product_id: option.dataset.productId
        });
      } else if (state === 'unavailable') {
        setOptionUnavailable(option);
      } else {
        fetchVariant(option);
      }
    });
  }

  function initializeWithin(container) {
    if (!container || !container.querySelectorAll) return;
    if (container.matches && container.matches(ROOT_SELECTOR)) initializeRoot(container);
    container.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches(QUANTITY_INPUT_SELECTOR)) return;

    var option = event.target.closest(OPTION_SELECTOR);
    var root = event.target.closest(ROOT_SELECTOR);
    if (!option || option.dataset.state === 'unavailable' || option.dataset.state === 'loading') return;
    if (!String(event.target.value || '').trim()) return;

    setOptionQuantity(option, event.target.value, { select: true });
    if (root) clearError(root);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches(CHECKBOX_SELECTOR)) {
      var checkboxOption = event.target.closest(OPTION_SELECTOR);
      var checkboxRoot = event.target.closest(ROOT_SELECTOR);
      if (checkboxOption) {
        var checkboxQuantity = event.target.checked ? optionSelectionQuantity(checkboxOption) : 0;
        setOptionQuantity(checkboxOption, checkboxQuantity, { select: false });
        setOptionSelectedState(checkboxOption);
        syncOptionQuantityControls(checkboxOption);
      }
      if (checkboxRoot) clearError(checkboxRoot);
      return;
    }

    if (!event.target.matches(QUANTITY_INPUT_SELECTOR)) return;
    var quantityOption = event.target.closest(OPTION_SELECTOR);
    var quantityRoot = event.target.closest(ROOT_SELECTOR);
    if (!quantityOption || quantityOption.dataset.state === 'unavailable' || quantityOption.dataset.state === 'loading') return;

    setOptionQuantity(quantityOption, event.target.value, { select: true });
    if (quantityRoot) clearError(quantityRoot);
  });

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest && event.target.closest(QUANTITY_BUTTON_SELECTOR);
    if (!quantityButton) return;

    event.preventDefault();
    event.stopPropagation();

    var option = quantityButton.closest(OPTION_SELECTOR);
    var root = quantityButton.closest(ROOT_SELECTOR);
    if (!option || quantityButton.disabled || option.dataset.state !== 'ready') return;

    var currentQuantity = getOptionQuantity(option);
    var limits = optionQuantityLimits(option);
    var isDecrease = quantityButton.matches(QUANTITY_DECREASE_SELECTOR);
    var checkbox = getOptionCheckbox(option);

    if (isDecrease && currentQuantity <= limits.selectedMinimum && checkbox && checkbox.checked) {
      setOptionQuantity(option, 0, { select: true });
      if (root) clearError(root);
      return;
    }

    var nextQuantity = isDecrease
      ? currentQuantity - 1
      : currentQuantity + 1;

    setOptionQuantity(option, nextQuantity, { select: true });
    if (root) clearError(root);
  });

  /* Capture phase: Gecko delegates both the main and sticky add-to-cart clicks.
     We only replace the native flow when at least one complementary option
     is selected; ordinary product additions therefore remain untouched. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var button = event.target.closest(SUBMIT_SELECTOR);
    var form = button && button.closest(FORM_SELECTOR);
    var root = getRootForForm(form);
    var overrides = null;

    if (!button) {
      button = event.target.closest(STICKY_SUBMIT_SELECTOR);
      if (!button) return;

      /* Gecko uses the first tap on the compact mobile sticky button to open
         its variant panel. Preserve that interaction; the second tap performs
         the actual multi-product add once Gecko removes data-action-delay. */
      if (button.hasAttribute('data-action-delay') && window.innerWidth <= 767) return;

      var stickyContext = getStickyContext(button);
      if (!stickyContext) return;
      form = stickyContext.form;
      root = stickyContext.root;
      overrides = {
        variantId: stickyContext.variantId,
        quantity: stickyContext.quantity
      };
    }

    if (!form || !root || selectedOptions(root).length === 0) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addBundle(form, root, button, overrides);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.matches && event.target.matches(FORM_SELECTOR) ? event.target : null;
    var root = getRootForForm(form);
    if (!root || selectedOptions(root).length === 0) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    addBundle(form, root, form.querySelector(SUBMIT_SELECTOR));
  }, true);

  if (window.jQuery_T4NT) {
    window.jQuery_T4NT(document).on('variant:changed.cdjProductUpsell', function (event) {
      var variant = event.currentVariant;
      if (!variant) return;

      document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        var form = getForm(root);
        if (!form || String(getSelectedVariantId(form)) !== String(variant.id)) return;
        root.dataset.parentVariantTitle = variant.title || '';
      });
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initializeWithin(node);
      });
    });
  });

  function initialize() {
    initializeWithin(document);
    if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
